import { ControlInterface } from 'edocatbase/Form';
import Editor from '../../../Editor/Editor';

const getTitleStyles = (disabled: boolean) => ({
	position: 'relative',
	bottom: '-8px',
	left: '10px',
	zIndex: '9',
	backgroundColor: 'white',
	width: '45px',
	padding: '0 5px',
	fontSize: '0.8rem !important',
	color: disabled ? 'rgba(0, 0, 0, 0.38)' : '#333',
});

interface RichTextProps extends ControlInterface {
	params: {
		[key: string]: any;
	};
	readOnly: boolean;
}

export default class RichText extends window.React.PureComponent<RichTextProps> {
	onBlur = () => {
		const { onBlur, name, value, dirty } = this.props;
		onBlur && onBlur(name, value, dirty);
	};

	onChange = (content: string) => {
		const { onChange, name, dirty } = this.props;
		onChange([name], content, dirty);
	};

	render() {
		const { autoFocus, value, label, mandatory, name, error, params, disabled, readOnly } = this.props;

		return readOnly ? (
			<div className={`form-row row-${name} simple-row`}>
				<label>{label}</label>
				{value ? (
					<div dangerouslySetInnerHTML={{ __html: value }} />
				) : (
					<div>{window.Alfresco.messages.global['label.none']}</div>
				)}
			</div>
		) : (
			<div className={`form-row row-${name}`} style={{ color: `${disabled ? 'rgba(0, 0, 0, 0.38)' : '#333'}` }}>
				<label htmlFor={name.replace(':', '_')} style={getTitleStyles(disabled)}>
					{label}
					{mandatory ? '*' : ''}
					<span className="error-title">{error}</span>
				</label>
				<Editor
					autoFocus={autoFocus}
					onChange={this.onChange}
					onBlur={this.onBlur}
					value={value}
					height={params.height}
					disabled={disabled}
				/>
			</div>
		);
	}
}
